// extracted by mini-css-extract-plugin
export default {"Container":"Dropdown_Container__KitUL","Tippy":"Dropdown_Tippy__67jCa"};